import React, { useState } from 'react';
import Section from '../components/Modular/Section';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
import Title from '../components/Title/Title';

import Layout from '../components/Modular/Layout';
import Unit from '../components/Modular/Unit';
import MicroUnit from '../components/Modular/MicroUnit';
import ServiceOffering from '../components/ServiceOffering/ServiceOffering';
import DropDown from '../components/DropDown/DropDown';
import { useWindowSize } from '../hooks/useWindowSize';
import ContactForm from '../components/ContactForm';
import Nav from '../components/Nav/Nav';

export const ContactPage: React.FC = () => {
  const windowSize = useWindowSize();
  const buttonLayout = windowSize.width <= 798 ? 'grid' : 'flex';
  const responsiveTitle = windowSize.width <= 798 ? 'center' : 'left';
  const responsiveWidth = windowSize.width <= 798 ? '3' : '9';
  const [navDropDown, setNavDropDown] = useState(false);

  const toggleNavMobile = () => {
    setNavDropDown((prev) => !prev);
  };

  const context = {
    section: {
      layout: 'grid',
      background: 'dark',
      justifyItems: 'center',
      gap: 'md',
    },
    unit: {
      colSpan: '1',
      rowSpan: '1',
      justifyContent: 'center',
      background: 'dark',
    },
  };
  return (
    <Layout
      layout="grid"
      gap="md"
      alignContent="center"
      justifyContent="center"
      background="dark"
      context={context}
    >
      <Section layout="grid" gap="md" paddingTop="xl">
        <Title responsiveTitle={responsiveTitle}></Title>

        <Section
          width={responsiveWidth}
          justifyContent="center"
          justifySelf="left"
          justifyItems="left"
        >
          <ContactForm />
        </Section>

        <Section
          layout={buttonLayout}
          gridTemplate={`${buttonLayout === 'grid' ? 'vertical-4' : ''}`}
          gap="sm"
          width={responsiveWidth}
          justifyContent="center"
          justifyItems="center"
        >
          {windowSize.width >= 798 && <Nav></Nav>}

          {windowSize.width <= 798 && (
            <DropDown
              navDropDown={navDropDown}
              toggleNavMobile={toggleNavMobile}
            ></DropDown>
          )}
        </Section>
      </Section>
    </Layout>
  );
};
